import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.BankAccountsPage.BankAccountCard.XeroIntegrationDisconnectedNotice', {
    xeroDisconnected: 'Xero is disconnected.',
});
